
import { Purchase } from "@/models/base";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import { printHumanFloat } from "@/utils/pretty-print";
import Vue from "vue";

export default Vue.extend({
	props: {
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		},
	},
	methods: {
		ledgerToText(ledger:PurchaseLedger):string{
			return `${ledger.LedgerCode} ${printHumanFloat(ledger.Amount)}`;
		},
	}
});
